var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cvss-score-box",style:(_vm.cvssStyle)},[_vm._v(" "+_vm._s(_vm.value)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }